import { configureStore } from '@reduxjs/toolkit';
import thunkMiddleware from 'redux-thunk';
import CustomerReducer from '../Reducers/CustomerReducer';

const store = configureStore({
  reducer: {
    customer: CustomerReducer,
    
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(thunkMiddleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
